/**
 * Founder avatar.
 *
 * A real face is the cheapest credibility boost the widget has — it reframes a
 * proactive message from "a bot is pestering me" to "the founder is reaching
 * out." Falls back to initials on a coloured chip when no photo is set or the
 * image fails to load, so a broken URL never shows a broken image.
 */
import { useState } from 'react';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '·';
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}

export function Avatar({
  name,
  src,
  size = 28,
}: {
  name: string;
  src?: string;
  size?: number;
}) {
  const [failed, setFailed] = useState(false);
  const dimension = { width: size, height: size };

  if (src && !failed) {
    return (
      <img
        className="avatar"
        src={src}
        alt={name || 'Founder'}
        style={dimension}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span className="avatar avatar-fallback" style={dimension} aria-hidden>
      {initials(name)}
    </span>
  );
}
